// extracted by mini-css-extract-plugin
export default {"sparkle":"sparkle--YFyx8","sparkles-come-in-out":"sparkles-come-in-out--kuAm0","sparkles-spin":"sparkles-spin--RPn16","sparkles-area-overlay":"sparkles-area-overlay--PYlLN"};